import { supabase } from '../client'
import type { UserSettings } from '../types'
import { logSupabaseError } from './logSupabaseError'

/* ── USER SETTINGS ─────────────────────────────────────────── */

/**
 * Get user settings
 */
export async function getUserSettings(userId: string): Promise<UserSettings | null> {
  if (!supabase) return null

  try {
    const { data, error } = await supabase
      .from('user_settings')
      .select('*')
      .eq('user_id', userId)
      .maybeSingle() // Verwende maybeSingle() statt single() - gibt null zurück wenn keine Daten

    if (error) {
      logSupabaseError('Get settings error', error)
      return null
    }

    return data
  } catch (error) {
    logSupabaseError('Get settings error', error)
    return null
  }
}

/**
 * Update user settings
 */
export async function updateUserSettings(
  userId: string,
  updates: Partial<Omit<UserSettings, 'id' | 'user_id' | 'created_at'>>
): Promise<boolean> {
  if (!supabase) return false

  try {
    const { error } = await supabase
      .from('user_settings')
      .update({
        ...updates,
        updated_at: new Date().toISOString(),
      })
      .eq('user_id', userId)

    if (error) {
      logSupabaseError('Update settings error', error)
      return false
    }

    return true
  } catch (error) {
    logSupabaseError('Update settings error', error)
    return false
  }
}
